<template>
    <div class="card orangopack-card">
        <div class="flex-shrink-1 body__images w-100 clickable" :style="imageBackground"></div>
        <div class="card-body">
            <div class="card-info mb-1">
                <div class="d-flex align-items-center font-13 line-height-18 mb-1">
                    <i class="fas fa-building text-gray-800 mr-1 font-10"></i>
                    <span class="text-truncate text-gray-500 font-12"
                          v-text="item.company.name"></span>
                </div>
                <p class="fw-600 mb-5 line-height-20 promotion-title"
                   v-html="getPromotionText"></p>
                <div class="d-flex align-items-center font-13 line-height-18 mb-2 border-bottom">
                    <i class="fas fa-map-marker-alt text-gray-800 mr-1 font-10"></i>
                    <span class="text-truncate text-gray-500 font-12"
                          v-text="formattedAddress"></span>
                </div>
                <div class="d-flex align-items-center justify-content-between orangopack-card__price-container">
                    <span class="badge badge-pill font-12 fw-600 badge-secondary" v-text="ageRange"></span>
                    <span class="font-20 fw-600 line-height-28">
                        <small class="font-10" v-if="item.promotions.length > 1">da</small> {{(totalPrice)}}€
                    </span>
                </div>
            </div>
            <button type="button" @click="onShowInvitation"
                    class="m-b-10 btn btn-primary btn-block p-t-10 p-b-10 fw-600 line-height-20">
                {{buttonLabelText}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CompanyOrangopackCard",
    props: {
        item: Object,
        buttonLabelText: {
            type: String,
            default: 'Scopri'
        }
    },
    data() {
        return {
            imageBackground: null,
            minPromotion: null,
        }
    },
    computed: {
        getPromotionText() {
            let lessons = this.minPromotion.lessons > 1 ? 'lezioni' : 'lezione'
            let people = this.minPromotion.people > 1 ? 'persone' : 'persona'
            let lessonType = this.minPromotion.lesson_type == 'group' ? 'di gruppo' : 'individuale'

            return `${this.minPromotion.lessons} ${lessons} di <span class='text-primary text-uppercase'>${this.item.sport.name} </span> per ${this.minPromotion.people} ${people}`
        },
        formattedAddress() {
            var string = "";
            this.item.municipality ? string += this.item.municipality : string += "";
            this.item.route ? (string += ", " + this.item.route ): string += "";
            this.item.house_number ? (string += " " + this.item.house_number ): string += "";
            return string;
        },
        ageRange(){
            return this.item.start_age + " - " + this.item.end_age + " anni";
        },
        totalPrice(){
            let total = parseFloat(this.minPromotion.price);
            if(this.item.active_promotion_fee){
                total += parseFloat(this.item.promo_membership_fee * this.minPromotion.people);
            }
            return total.toFixed(2)
        }
    },
    mounted() {
        this.getImageBackground()
        this.getMinPromotion();        
    },
    methods: {
        getMinPromotion() {
            this.$set(this, 'minPromotion', _.minBy(this.item.promotions, i => i.price))
        },
        getImageBackground() {
            if (!_.isEmpty(this.item.course_thumb_image)) {
                this.$set(this, 'imageBackground', {
                    'background-image': `url(${this.item.course_thumb_image_full})`
                })
            }
            this.$set(this, 'imageBackground', {
                'background-image': `url("${this.item.course_image}")`
            })
        },
        onShowInvitation() {
            window.open(route('courses.promotion.show', this.item.slug))
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyOrangopackCard.vue